import { render } from "./beautyVideoInfo.vue?vue&type=template&id=0744287e&scoped=true"
import script from "./beautyVideoInfo.vue?vue&type=script&lang=js"
export * from "./beautyVideoInfo.vue?vue&type=script&lang=js"

import "./beautyVideoInfo.vue?vue&type=style&index=0&id=0744287e&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0744287e"]])

export default __exports__